import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

const Button = styled(AntdButton).withConfig({
    shouldForwardProp: prop => !['porscheFallbackIcon', 'porscheFallbackIconSource', 'showIcon'].includes(prop),
})`
    &.ant-btn {
        min-width: 70px;
        height: 45px;
        border-radius: 25px;
        font-weight: 900;
        text-transform: uppercase;
        font-size: var(--button-font-size, 1rem);
        display: inline-flex;
        align-items: center;
        justify-content: center;

        ${({ size = 'large' }) =>
            size === 'large' &&
            `
                min-width: 180px;
            `}

        & span {
            pointer-events: none;
            line-height: 16px;
            height: 16px;
            display: flex;
            align-items: center;
        }

        & .anticon {
            font-size: inherit;
        }

        &.ant-btn-default {
            border: 1px solid rgba(55, 55, 55, 0.2);
            color: #4a4a4a;

            &:hover {
                border-color: #373737;
            }
        }

        &.ant-btn-secondary {
            background-color: var(--ant-primary-color);
            border-color: var(--ant-primary-color);
            color: #fff;

            &:hover {
                border-color: #373737;
            }
        }

        &.ant-btn-tertiary {
            color: #4a4a4a;

            &:hover {
                border-color: #373737;
            }
        }

        &.ant-btn-link {
            border: none;
            width: fit-content;
            min-width: initial;
            border-color: transparent;

            > svg {
                fill: currentColor;
            }

            > svg + span {
                margin-left: 8px;
                margin-top: 2px;
            }
        }
    }
`;

export default Button;
